<template>
  <div class="module-wrap module-knowlege-miss">
    <div class="chart-title">
      <h5 class="ch-title">知识漏洞占比</h5>
    </div>

    <div class="chart-wrap">
      <div class="pie-mask"></div>
      <div class="pie-mask-two"></div>
      <div id="pieMiss" class="pie-custom" style="width: 100%; height: 360px"></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import ChartLi from './ChartLi';
export default {
  name: 'ModuleKnowlegePieMiss',
  data() {
    return {
      intervalNum: 0,
    };
  },

  props: {
    moduleTitle: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      require: true,
    },
    chartId: {
      type: String,
      required: true,
    },
    missPieData: {
      type: Array,
      required: true,
    },
  },

  components: {
    ChartLi,
  },
  mounted() {
    console.log(this.missPieData.length, 222);
    this.renderPie(this.missPieData, ['']);
  },
  methods: {
    renderPie(data, text) {
      const dom = document.getElementById('pieMiss');
      const myChart = echarts.init(dom);
      let option = null;
      option = {
        // tooltip : {
        //   trigger: 'item',
        //   formatter: "{a} <br/>{b}"
        // },
        series: [
          {
            name: '漏洞占比',
            type: 'pie',
            selectedMode: 'single',
            center: ['50%', '50%'],
            radius: ['0', '90%'],
            selectedOffset: 6,
            data,
            minAngle: 10,
            hoverAnimation: false,
            avoidLabelOverlap: false,
            itemStyle: {
              emphasis: {
                itemStyle: {
                  borderColor: '#f3f3f3',
                  borderWidth: 20,
                },
              },
              normal: {
                borderWidth: 0,
                borderColor: '#ffffff',
                label: {
                  color: '#333',
                  fontSize: 16,
                  formatter(val) {
                    console.log(val, '每个漏洞');
                    const str = `知识漏洞${val.value}个`;
                    return str;
                  },
                },
                color(params) {
                  console.log(params, 'name');
                  // 自定义颜色
                  const colorList = [['#7CD7FF', '#4E74FF'], ['#E4EAFF', '#E1F5FF']];
                  const obj = {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0, color: colorList[params.dataIndex][0], // 0% 处的颜色
                    }, {
                      offset: 1, color: colorList[params.dataIndex][1], // 100% 处的颜色
                    }],
                    global: false, // 缺省为 false
                  };
                  return obj;
                  // return colorList[params.dataIndex]
                },
              },
            },
          },
          {
            name: '漏洞占比',
            type: 'pie',
            selectedMode: 'single',
            center: ['50%', '50%'],
            radius: ['40%', '90%'],
            data,
            hoverAnimation: false,
            avoidLabelOverlap: false,
            minAngle: 10,
            itemStyle: {
              emphasis: {
                itemStyle: {
                  borderColor: '#f3f3f3',
                  borderWidth: 20,
                },
              },
              normal: {
                borderWidth: 0,
                borderColor: '#ffffff',
                label: {
                  position: 'inner',
                  align: 'left',
                  fontSize: 18,
                  color: '#333333',
                },
                labelLine: {
                  show: false,
                },
                color(params) {
                  console.log(params, 'name');
                  // 自定义颜色
                  const colorList = ['rgba(124, 215, 255, 0)', 'rgba(124, 215, 255, 0)'];
                  return colorList[params.dataIndex];
                },
              },
            },
          },
        ],
      };
      if (option && typeof option === 'object') {
        myChart.setOption(option, true);
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .module-knowlege-miss {
    position: relative;
    padding-top: 20px;
    .chart-title{
      position: relative;
      .ch-title{
        position: absolute;
        width: 117px;
        height: 28px;
        left: 32px;
        background: linear-gradient(90deg, #E4EAFF 0%, #E1F5FF 100%);
        border-radius: 14px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 28px;
        text-align: center;
      }
    }
    .chart-wrap {
      position: relative;
      .pie-mask{
        position: absolute;
        border-radius: 50%;
        width: 156px;
        height: 156px;
        top: 50%;
        left: 50%;
        z-index: 9;
        transform: translate(-50%, -50%);
        background: #FFFFFF;
        box-shadow: 0px 0px 12px 0px rgba(102, 102, 102, 0.35);
      }
      .pie-mask-two{
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 10;
        background: rgba(0,0,0, 0);
      }
    }
    .chart {
      width: 666px;
      height: 360px;
      margin: 32px auto 0;
      .xAxis-label {
        width: 100px;
      }
    }
    .chart-drag-notice {
      position: absolute;
      top: 75px;
      right: 70px;
      font-size: 12px;
      color: #666;
    }
  }
  .chart-tip-wrap{
    padding: 40px;
    font-size: 28px;
    line-height: 42px;
    box-shadow: 0 0 0 5px #ccc;
  }

</style>
<style scoped>
  @media screen and (max-device-width: 1024px) {
    .chart {
      width: 300px;
    }
  }

</style>
